import Vue from 'vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './utils/rem.js'
Vue.use(ElementUI);
import App from './App.vue'
Vue.config.productionTip = false

new Vue({
  router,
  store,
  el: '#app',
  render: function (h) { return h(App) }
}).$mount('#app')
